module.exports = __webpack_public_path__ + "files/3d24f7e554a9e2056a492a9e11d94a93.svg";